




































































































































import {Prop} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';

import storeEssenceAchat, {EssenceAchatFilter} from '@/stores/modules/essenceAchat';

import CrudList from '@/components/Crud/List.vue';
import TableHead from '@/components/Paginate/TableHead.vue';
import TableCell from '@/components/Paginate/TableCell.vue';
import Checked from '@/components/Checked.vue';
import {Stored} from "vue-stored-prop-decorator/index";
import storeUser from "@/stores/modules/user";
import {Token, User} from "@/models";
import storeToken from "@/stores/modules/token";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import 'devextreme/dist/css/dx.light.css';
	import {
			DxDataGrid,
			DxColumn,
			DxEditing,
			DxFilterRow,
			DxHeaderFilter,
			DxGroupPanel,
			DxGrouping,
			DxScrolling,
			DxSummary,
			DxLookup,
			DxTotalItem,
			DxGroupItem,
			DxMasterDetail,
			DxStringLengthRule,
			DxRequiredRule,
			DxRangeRule,
			DxValueFormat,
			DxPaging,
			DxPager,
			DxExport,
			DxStateStoring,
		} from 'devextreme-vue/data-grid';
import DxButton from 'devextreme-vue/button';
import axios from "axios";

@Component({
	components: {
		DxButton,
			DxDataGrid,
			DxColumn,
			DxEditing,
			DxFilterRow,
			DxHeaderFilter,
			DxGroupPanel,
			DxGrouping,
			DxScrolling,
			DxSummary,
			DxLookup,
			DxTotalItem,
			DxGroupItem,
			DxMasterDetail,
			DxStringLengthRule,
			DxRangeRule,
			DxRequiredRule,
			DxValueFormat,
			DxPaging,
			DxPager,			
			DxExport,
			DxStateStoring,
		CrudList,
		TableHead,
		TableCell,
		Checked,
	}
})
export default class CrudEssenceAchatList extends Vue {
	@Stored(() => storeUser) me!: User;
	@Stored(() => storeToken) token!: Token;

	private dataGrid;

	private url = process.env.VUE_APP_BACK_BASE_URL + '/api/essenceAchats'

	private dataSource = null;
	private dataSourceTotal = null;

	public async mounted(): Promise<void>  {
		this.dataGrid = this.$refs['dataGridRefKey'] as DxDataGrid
		this.refresh();
	}

	public refresh()
	{
		// on change la source
		this.dataSource = createStore({
				key: 'id',
				loadUrl: `${this.url}/fetch`,
				onBeforeSend: (method, ajaxOptions) => {
					ajaxOptions.xhrFields = { withCredentials: true };
					ajaxOptions.headers = {
						'Authorization': 'BEARER ' + this.token.id
					}
				},
			});
	}

		public onContentReady()
		{
			console.log(this.dataGrid.instance.getCombinedFilter());
			this.getTotaux();
		}

		public async getTotaux(): Promise<void> 
		{
			var $filters = this.dataGrid.instance.getCombinedFilter();
			if ($filters)
			{
				await axios.get(this.url + "/fetch-totaux?filter=" + JSON.stringify($filters) + "&token=" + this.token.id, {}).then(async response => {
				this.dataSourceTotal = await response.data;
				});
			}
			else
			{
				await axios.get(this.url + "/fetch-totaux?token=" + this.token.id, {}).then(async response => {
				this.dataSourceTotal = await response.data;
				});
			}
		}

	public clearFilters() {
		this.dataGrid.instance.clearFilter()
		this.dataGrid.instance!.state(null);
		this.refresh();
	}

	public onRowPrepared(e) {
            if (e.rowType === "data") {
                if ((e.dataIndex % 2) != 0) {
                    e.rowElement.style.cssText = "background-color: #eeeeee;";
				}
                if (e.data.fin_coupe == "1") {
                    e.rowElement.style.cssText = "color: gray; background-color: lightgreen;";
                }
            }
        }		

		private calculateCellValue(data) {
			let date = data.date
			let year = date.substr(2,2)
			let month = date.substr(5,2)
			let day = date.substr(8,2)
			return day + '/' + month + '/' + year
		}

}
